module.exports = __webpack_public_path__ + "img/saturday-schedule.37261056.png";